module.exports = __webpack_public_path__ + "static/media/ai.47ae0093.svg";